export const MAXIMUM_FILE_UPLOAD_SIZE = 10;

export const ALLOWED_FILE_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
};
